<template>
  <div class="free-container" v-if="freeOrder && (freeOrder.freeOrderLimitCountStr || freeOrder.freeOrderUsedUpMsg || (freeOrder.freeOrderRecordList && freeOrder.freeOrderRecordList.length > 0))">
    <div class="free-header" v-if="freeOrder.freeOrderLimitCountStr || freeOrder.freeOrderUsedUpMsg" :class="{'free-header-single': freeOrder.freeOrderRecordList.length > 0}">
      <div class="free-title">
        <img src="@/assets/ticket/freeOrder/free-tag.png" alt="">
        <div class="free-title-text" v-html="freeOrder.freeOrderUsedUpMsg || freeOrder.freeOrderLimitCountStr"></div>
        <div v-if="freeOrder.updateTimeStr && !freeOrder.freeOrderUsedUpMsg" class="time">
          <img src="@/assets/ticket/freeOrder/clock.png" alt="">
          <span class="free-update-time">{{ freeOrder.updateTimeStr }}</span>
          <span>更新</span>
        </div>
      </div>
      <div class="free-refresh" @click="refreshfreeOrderRecord" :class="{ disabled: !isDataLoaded, refreshing: isRefreshing }" v-if="!freeOrder.freeOrderUsedUpMsg">
        <img src="@/assets/ticket/freeOrder/refresh.png" alt="">
        刷新
      </div>
    </div>
    <div class="free-order-scroll-wrapper" :class="{'free-order-scroll-wrapper-single': freeOrder.freeOrderRecordList.length <= 1}" v-if="freeOrder && freeOrder.freeOrderRecordList && freeOrder.freeOrderRecordList.length > 0">
      <div class="free-wrapper" ref="scrollWrapper">
        <div class="free-content" ref="scrollContent">
            <!-- 第一组数据 -->
            <div class="free-flex-container">
              <!-- 第一行 -->
              <div class="free-row">
                <div 
                  class="free-item"
                  :class="freeOrder.freeOrderRecordList.length <= 4 ? 'free-item-single' : ''"
                  v-for="(item, index) in row1Data"
                  :key="'row1-' + index"
                  :style="{ backgroundColor: item.bgColor }"
                >
                  <div class="free-item-img" :style="{ borderColor: item.circleColor }">
                    <img :src="item.productImgUrl" alt="商品图片">
                    <div class="free-item-num" v-if="item.productSkuNum && item.productSkuNum > 1">共{{ item.productSkuNum }}件</div>
                  </div>
                  <div class="free-item-body">
                    <div class="free-item-left">
                      <div class="free-item-info">
                        <div class="free-item-location">
                          {{ item.cityName }}
                        </div>
                        <div class="free-item-mobile">{{ item.nickName }}</div>
                        <div class="free-item-time">{{ item.freeOrderTime }}</div>
                      </div>
                    </div>
                    <div class="free-item-right">
                      <div class="free-item-spu" :style="{ color: item.charsColor }">{{ item.productName }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 第二行 -->
              <div class="free-row">
                <div 
                  class="free-item"
                  :class="freeOrder.freeOrderRecordList.length <= 4 ? 'free-item-single' : ''"
                  v-for="(item, index) in row2Data"
                  :key="'row2-' + index"
                  :style="{ backgroundColor: item.bgColor }"
                >
                  <div class="free-item-img" :style="{ borderColor: item.circleColor }">
                    <img :src="item.productImgUrl" alt="商品图片">
                    <div class="free-item-num" v-if="item.productSkuNum && item.productSkuNum > 1">共{{ item.productSkuNum }}件</div>
                  </div>
                  <div class="free-item-body">
                    <div class="free-item-left">
                      <div class="free-item-info">
                        <div class="free-item-location">
                          {{ item.cityName }}
                        </div>
                        <div class="free-item-mobile">{{ item.nickName }}</div>
                        <div class="free-item-time">{{ item.freeOrderTime }}</div>
                      </div>
                    </div>
                    <div class="free-item-right">
                      <div class="free-item-spu" :style="{ color: item.charsColor }">{{ item.productName }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 第二组数据（复制一份实现无缝滚动） -->
            <div class="free-flex-container" v-if="freeOrder.freeOrderRecordList.length > 4">
              <!-- 第一行 -->
              <div class="free-row">
                <div 
                  class="free-item"
                  v-for="(item, index) in row1Data"
                  :key="'row1-copy-' + index"
                  :style="{ backgroundColor: item.bgColor }"
                >
                  <div class="free-item-img" :style="{ borderColor: item.circleColor }">
                    <img :src="item.productImgUrl" alt="商品图片">
                    <div class="free-item-num" v-if="item.productSkuNum && item.productSkuNum > 1">共{{ item.productSkuNum }}件</div>
                  </div>
                  <div class="free-item-body">
                    <div class="free-item-left">
                      <div class="free-item-info">
                        <div class="free-item-location">
                          {{ item.cityName }}
                        </div>
                        <div class="free-item-mobile">{{ item.nickName }}</div>
                        <div class="free-item-time">{{ item.freeOrderTime }}</div>
                      </div>
                    </div>
                    <div class="free-item-right">
                      <div class="free-item-spu" :style="{ color: item.charsColor }">{{ item.productName }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 第二行 -->
              <div class="free-row">
                <div 
                  class="free-item"
                  v-for="(item, index) in row2Data"
                  :key="'row2-copy-' + index"
                  :style="{ backgroundColor: item.bgColor }"
                >
                  <div class="free-item-img" :style="{ borderColor: item.circleColor }">
                    <img :src="item.productImgUrl" alt="商品图片">
                    <div class="free-item-num" v-if="item.productSkuNum && item.productSkuNum > 1">共{{ item.productSkuNum }}件</div>
                  </div>
                  <div class="free-item-body">
                    <div class="free-item-left">
                      <div class="free-item-info">
                        <div class="free-item-location">
                          {{ item.cityName }}
                        </div>
                        <div class="free-item-mobile">{{ item.nickName }}</div>
                        <div class="free-item-time">{{ item.freeOrderTime }}</div>
                      </div>
                    </div>
                    <div class="free-item-right">
                      <div class="free-item-spu" :style="{ color: item.charsColor }">{{ item.productName }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryFreeOrderDetail } from '@/api/index.js'

export default {
  name: 'freeOrderRecord',
  components: {
  },
  props: {
    activityNo: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      freeOrder: {
        freeOrderLimitCountStr: '',
        freeOrderUsedUpMsg: '',
        updateTimeStr: '',
        freeOrderRecordList: [],
      },
      colorList: [],
      isDataLoaded: false, // 添加数据加载状态标志
      isRefreshing: false, // 添加正在刷新状态标志
      scrollAnimation: null, // 滚动动画ID
      scrollSpeed: 0.5, // 滚动速度
      isScrolling: false, // 是否正在滚动
      scrollListeners: null, // 滚动事件监听器引用
      scrollTimeout: null // 滚动结束后的定时器
    };
  },
  computed: {
    row1Data() {
      return this.freeOrder.freeOrderRecordList.filter((_, index) => index % 2 === 0);
    },
    // 第二行数据（奇数索引）
    row2Data() {
      return this.freeOrder.freeOrderRecordList.filter((_, index) => index % 2 === 1);
    }
  },
  mounted() {
    // 初始化时先获取数据
    this.fetchFreeOrderData();
    
    // 监听手动滚动事件
    this.$nextTick(() => {
      this.addScrollListeners();
    });
    this.$sensors.track("mkt_couponClaim_freeOrder_view", {
      activity_id: this.activityNo || '',
    });
  },
  watch: {
    // 监听数据变化，重新初始化滚动
    'freeOrder.freeOrderRecordList': {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.stopScrollAnimation();
          this.startScrollAnimation();
        });
      }
    }
  },
  beforeUnmount() {
    // 组件销毁前停止滚动动画
    this.stopScrollAnimation();
    
    // 移除滚动事件监听器
    this.removeScrollListeners();
  },
  methods: {
    // 模拟接口请求获取免单数据
    fetchFreeOrderData() {
      // 设置正在刷新状态
      this.isRefreshing = true;
      // 模拟接口请求延迟
      setTimeout(() => {
        queryFreeOrderDetail({
          activityNo: this.activityNo,
        }).then(res => {
          if (res.code == 200 && res.data) {
            this.freeOrder = res.data
            this.freeOrder.freeOrderRecordList = res.data.freeOrderRecordList || []
            this.colorList = JSON.parse(res.data.freeOrderDisplayColor || '{}')?.colorList || []
            this.isDataLoaded = true // 数据加载完成
            // 数据加载完成，初始化列表
            this.initializeFreeList();
          }
        }).finally(() => {
          // 无论请求成功与否，都清除刷新状态
          this.isRefreshing = false;
        })
      }, 500); // 模拟500ms的接口请求延迟
    },
    
    // 初始化列表数据
    initializeFreeList() {
      // 先复制原始数据到新数组
      const newList = [...this.freeOrder.freeOrderRecordList];
      
      // 为前10个项目计算颜色
      for (let i = 0; i < Math.min(10, newList.length); i++) {
        newList[i] = {
          ...newList[i],
          ...this.getBackgroundColor(newList[i].productName)
        };
      }
      
      // 直接更新列表数据，渲染全部列表
      this.freeOrder.freeOrderRecordList = newList;
      
      // 异步为剩余项目逐个计算颜色
      this.updateRemainingColors(newList);
      
      // 等待DOM更新后开始滚动
      this.$nextTick(() => {
        this.startScrollAnimation();
      });
    },
    
    // 异步为剩余项目逐个计算颜色
    updateRemainingColors(newList) {
      // 使用setTimeout将颜色计算放入下一个事件循环
      setTimeout(() => {
        // 从第10个项目开始计算颜色
        for (let i = 10; i < newList.length; i++) {
          // 为每个后续项目设置微小延迟，避免一次性计算所有
          setTimeout(() => {
            // 计算当前项目的颜色
            const color = this.getBackgroundColor(newList[i].productName);
            
            // 使用Vue.set确保响应式更新
            this.$set(this.freeOrder.freeOrderRecordList[i], 'bgColor', color.bgColor);
            this.$set(this.freeOrder.freeOrderRecordList[i], 'circleColor', color.circleColor);
            this.$set(this.freeOrder.freeOrderRecordList[i], 'charsColor', color.charsColor);
          }, (i - 10) * 20); // 每个项目间隔20ms
        }
      }, 0);
    },
    
    // 启动滚动动画
    startScrollAnimation() {
      // 增加重试机制，确保DOM完全渲染
      const attemptStart = () => {
        if (!this.$refs.scrollWrapper || !this.$refs.scrollContent || this.isScrolling) {
          // 如果DOM未准备好，重试
          setTimeout(() => attemptStart(), 100);
          return;
        }
        
        const scrollWrapper = this.$refs.scrollWrapper;
        const scrollContent = this.$refs.scrollContent;
        
        // 强制回流以确保正确计算宽度
        scrollWrapper.offsetHeight;
        scrollContent.offsetHeight;
        
        // 计算滚动距离
        const wrapperWidth = scrollWrapper.clientWidth;
        // 总内容宽度是两组数据的宽度
        const totalContentWidth = scrollContent.scrollWidth;
        // 计算单组数据宽度（考虑可能的小数精度问题）
        const singleGroupWidth = Math.ceil(totalContentWidth / 2);
        
        // 如果内容宽度小于容器宽度，不需要滚动
        // 增加容错值，避免因为小数精度问题导致无法滚动
        if ((singleGroupWidth <= wrapperWidth + 1) || this?.freeOrder?.freeOrderRecordList?.length <= 4) {
          return;
        }
        // 标记正在滚动
        this.isScrolling = true;
        
        // 根据设备类型设置不同的滚动参数
        const isMobile = window.innerWidth < 2000;
        const scrollStep = isMobile ? 1 : this.scrollSpeed; // 移动端使用整数步长避免精度问题
        const scrollInterval = isMobile ? 16 : 10; // 控制滚动更新频率，调整为稍微快一点的速度
        
        let lastScrollTime = 0;
        
        // 滚动动画函数
        const animateScroll = (timestamp) => {
          if (!this.isScrolling || !scrollWrapper) {
            return;
          }
          
          // 控制滚动更新频率
          if (timestamp - lastScrollTime >= scrollInterval) {
            // 计算当前滚动位置
            let currentScrollLeft = scrollWrapper.scrollLeft;
            
            // 滚动位置持续累积
            currentScrollLeft += scrollStep;
            
            // 应用滚动位置
            scrollWrapper.scrollLeft = currentScrollLeft;
            
            // 当滚动位置超过单组数据宽度时，重置滚动位置，但视觉上会无缝过渡到下一组数据
            if (currentScrollLeft >= singleGroupWidth) {
              scrollWrapper.scrollLeft = 0;
            }
            
            // 更新上次滚动时间
            lastScrollTime = timestamp;
          }
          
          // 继续下一帧动画
          this.scrollAnimation = requestAnimationFrame(animateScroll);
        };
        
        // 开始动画
        this.scrollAnimation = requestAnimationFrame(animateScroll);
      };
      
      // 开始尝试启动滚动
      attemptStart();
    },
    
    // 添加滚动事件监听器
    addScrollListeners() {
      const scrollWrapper = this.$refs.scrollWrapper;
      if (!scrollWrapper) return;
      
      // 滚动开始时的处理函数
      const handleScrollStart = () => {
        this.stopScrollAnimation();
      };
      
      // 滚动结束时的处理函数
      const handleScrollEnd = () => {
        // 用户停止滚动后，延迟2秒恢复自动滚动
        this.scrollTimeout = setTimeout(() => {
          this.startScrollAnimation();
        }, 2000);
      };
      
      // 添加事件监听器
      scrollWrapper.addEventListener('touchstart', handleScrollStart);
      scrollWrapper.addEventListener('touchmove', handleScrollStart);
      scrollWrapper.addEventListener('touchend', handleScrollEnd);
      scrollWrapper.addEventListener('touchcancel', handleScrollEnd);
      
      // 保存事件监听器引用，以便后续移除
      this.scrollListeners = {
        handleScrollStart,
        handleScrollEnd
      };
    },
    
    // 移除滚动事件监听器
    removeScrollListeners() {
      const scrollWrapper = this.$refs.scrollWrapper;
      if (!scrollWrapper || !this.scrollListeners) return;
      
      // 移除事件监听器
      scrollWrapper.removeEventListener('touchstart', this.scrollListeners.handleScrollStart);
      scrollWrapper.removeEventListener('touchmove', this.scrollListeners.handleScrollStart);
      scrollWrapper.removeEventListener('touchend', this.scrollListeners.handleScrollEnd);
      scrollWrapper.removeEventListener('touchcancel', this.scrollListeners.handleScrollEnd);
      
      // 清除定时器
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
        this.scrollTimeout = null;
      }
      
      // 重置引用
      this.scrollListeners = null;
    },
    
    // 停止滚动动画
    stopScrollAnimation() {
      this.isScrolling = false;
      
      if (this.scrollAnimation) {
        cancelAnimationFrame(this.scrollAnimation);
        this.scrollAnimation = null;
      }
      
      // 清除滚动结束的定时器
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
        this.scrollTimeout = null;
      }
    },
    
    // 刷新免单记录
    refreshfreeOrderRecord() {
      // 只有在数据加载完成后才允许刷新
      if (this.isDataLoaded) {
        // 停止当前滚动动画
        // this.stopScrollAnimation();
        // 重新获取数据
        this.fetchFreeOrderData();
        this.$sensors.track("mkt_couponClaim_freeOrder_refresh", {
          activity_id: this.activityNo || '',
        });
      }
    },
    
    // 根据productName获取背景色
    getBackgroundColor(productName) {
      // 默认颜色作为后备
      let color = {
        bgColor: '#F5F5F5', 
        circleColor: '#EEEEEE',
        charsColor: '#000000',
      }
      if (productName && typeof productName === 'string') {
        // 使用find方法查找匹配的颜色项，检查productName是否包含item.words数组中的任何一个元素
        const matchedColorItem = this.colorList.find(item => 
          item.words && item.words.some(word => productName.includes(word))
        );
        if (matchedColorItem) {
          // 如果找到匹配项，则使用对应的bgColor, circleColor, charsColor
          color = {
            bgColor: matchedColorItem.bgColor,
            circleColor: matchedColorItem.circleColor,
            charsColor: matchedColorItem.charsColor,
          }
        } else {
          // 如果没有匹配项，随机从colorList中选择一个颜色
          if (this.colorList.length > 0) {
            const randomIndex = Math.floor(Math.random() * this.colorList.length);
            color = {
              bgColor: this.colorList[randomIndex].bgColor,
              circleColor: this.colorList[randomIndex].circleColor,
              charsColor: this.colorList[randomIndex].charsColor,
            }
          }
        }
      } else if (this.colorList.length > 0) {
        // 如果productName无效，也随机从colorList中选择一个颜色
        const randomIndex = Math.floor(Math.random() * this.colorList.length);
        color = {
          bgColor: this.colorList[randomIndex].bgColor,
          circleColor: this.colorList[randomIndex].circleColor,   
          charsColor: this.colorList[randomIndex].charsColor,
        }
      }
      return color;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep b {
  color: #A52337 !important;
  font-weight: 600 !important;
  margin: 0 8px !important;
}
.free-container {
  width: 100%;
  position: relative;
  padding: 16px 24px 16px 24px !important;
}

.free-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  // align-items: center;
  box-sizing: border-box;
}
.free-header-single {
  margin-bottom: 16px;
}

.free-title {
  font-size: 28px;
  font-weight: 600;
  color: #3A3B3C;
  display: flex;
  align-items: center;
  img {
    width: 136px;
  }
  .free-title-text {
    margin-left: 16px;
    font-weight: 600;
    font-size: 28px;
    margin-top: 2px;
  }
  .time {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 8px;
    padding: 4px 8px;
    background: #FFF4E6;
    border-radius: 76px;
    img {
      width: 20px;
    }
    .free-update-time {
      font-size: 20px;
      font-weight: 400;
      color: #D57500;
      margin: 0px 4px;
    }
    span:last-child {
      font-size: 20px;
      font-weight: 400;
      color: #D57500;
    }
  }
}

.free-refresh {
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: 600;
  color: #999999;
  img {
    width: 24px;
    margin-right: 4px;
    transition: transform 0.3s ease;
  }
  cursor: pointer;
  transition: opacity 0.3s;
  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  &.refreshing img {
    animation: spin 1s linear infinite;
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.free-order-scroll-wrapper {
  width: calc(100% + 48px);
  margin-left: -24px;
  overflow: hidden;
  // position: absolute;
  height: 195px;
  margin-bottom: 16px;
}
.free-order-scroll-wrapper-single {
  height: 88px;
}

.free-wrapper {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
  white-space: nowrap;
  
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Edge */
  }
}

.free-content {
  display: flex;
  width: max-content;
  overflow: visible;
  // padding: 0 24px;
}

.free-flex-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex-shrink: 0;
  width: fit-content;
  margin-bottom: 24px;
  // padding: 0 24px;
}

.free-row {
  display: flex;
  // gap: 24px;
  flex-shrink: 0;
}

.free-item {
  display: flex;
  align-items: center;
  background-color: #F8F8F8;
  padding: 0 30px 0 6px;
  transition: all 0.3s ease;
  flex-shrink: 0;
  box-sizing: border-box;
  border-radius: 72px;
  height: 88px;
  margin-left: 24px;
}
.free-row .free-item-single:last-child {
  margin-right: 24px;
}
.free-item-body {
  display: flex;
  flex-direction: column;
  // margin-left: 8px;
  padding: 12px 0 10px 0;
}

.free-item-left {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}

.free-item-img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 8px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ffffff;
  position: relative;
  margin-left: -2px;
}

.free-item-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.free-item-num {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  font-size: 16px;
  text-align: center;
  padding: 4px 0;
  border-radius: 0 0 40px 40px;
}

.free-item-info {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.free-item-location {
  font-size: 20px;
  font-weight: 400;
  color: #000000;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.free-item-mobile {
  font-size: 20px;
  color: #000000;
  margin-left: 8px;
}

.free-item-time {
  font-size: 20px;
  color: #666666;
  margin-left: 8px;
}

.free-item-right {
  display: flex;
  align-items: center;
  margin-top: 12px;
}

.free-item-spu {
  font-size: 24px;
  font-weight: 600;
  color: #000000;
}
</style>